module.exports = __webpack_public_path__ + "img/507610f.svg";